import { IntlProvider } from 'react-intl';
import { getMessages } from '../../BCIntl/helper/getMessages';
import { IIntlProps } from '../entities';

const BCIntlProvider = (props: IIntlProps) => {
	const messages = getMessages();

	const defaultLanguage = props.defaultLanguage ? props.defaultLanguage : 'en-US';
	const defaultLocale = defaultLanguage.slice(0, 2);
	const locale = localStorage.locale ? localStorage.locale.slice(0, 2) : defaultLocale;
	const message = messages?.[locale] || messages[defaultLocale];

	return (
		<IntlProvider
			locale={locale}
			messages={message}
		>
			{props.children}
		</IntlProvider>
	);
};
export default BCIntlProvider;
